// extracted by mini-css-extract-plugin
export var columnList = "_fv-0";